module.exports = __webpack_public_path__ + "static/media/st_details_export.090ff01f.svg";